import React from 'react';
import {Link} from 'react-router-dom'
import './index.css'
import logo from './../../pic/logo.png'
import logo1 from './../../pic/logo1.png'
var isMobile = false;
const width = document.body.clientWidth;
if(width < 600){
    isMobile = true;
}
export default class Navigation extends React.Component {
    state = {
        isMobile
    }
    render() {
        return (
            <div>
                {!this.state.isMobile ? (
                    <section className="nav">
                        <div className="inner">
                            <div className="logo">
                                <img src={logo} alt=""></img>
                            </div>
                            <div className="tab">
                            <Link to="/about"><div style={{borderBottom:this.props.tab === 'about' ? '.04rem solid #FF5D38' : ''}}><b>关于我们</b></div></Link>
                            <Link to="/equipment"><div style={{borderBottom:this.props.tab === 'equipment' ? '.04rem solid #FF5D38' : ''}}>器材</div></Link>
                            <Link to="/train"><div style={{borderBottom:this.props.tab === 'train' ? '.04rem solid #FF5D38' : ''}}>培训</div></Link>
                            <Link to="/culture"><div style={{borderBottom:this.props.tab === 'culture' ? '.04rem solid #FF5D38' : ''}}>文化</div></Link>
                            <Link to="/match"><div style={{borderBottom:this.props.tab === 'match' ? '.04rem solid #FF5D38' : ''}}>赛事</div></Link>
                            <Link to="/info"><div style={{borderBottom:this.props.tab === 'info' ? '.04rem solid #FF5D38' : ''}}>资讯</div></Link>
                            <Link to="/index"><div style={{borderBottom:this.props.tab === 'index' ? '.04rem solid #FF5D38' : ''}}>首页</div></Link>
                            </div>
                        </div>
                    </section>
                ) : (
                    <div class="inner1">
                        <img src={logo1}></img>
                        <div>
                            咨询
                        </div>
                    </div>
                )}
            </div>
        );
    }
}